if (!customElements.get('db-sticky-atc')) {
  customElements.define(
    'db-sticky-atc',
    class DbStickyAtc extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.mainButton = this.form && this.form.querySelector('[name="add"]');
        if (!this.mainButton) return;

        this.hidden = false;
        this.button = this.querySelector('.db-sticky-atc__button');
        this.price = this.querySelector('.db-sticky-atc__price');
        this.button.addEventListener('click', () => this.mainButton.click());

        // Visible seulement quand le bouton principal est passé au-dessus de l'écran.
        // (Un IntersectionObserver rate les défilements rapides qui sautent par-dessus le bouton.)
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.classList.toggle('is-visible', this.mainButton.getBoundingClientRect().bottom < 0);
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();

        // Reflète l'état du bouton principal (variante épuisée, chargement…)
        this.mirror = new MutationObserver(() => this.sync());
        this.mirror.observe(this.mainButton, { attributes: true, childList: true, subtree: true, characterData: true });

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => this.syncPrice());
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        if (this.mirror) this.mirror.disconnect();
        if (this.unsubscribe) this.unsubscribe();
      }

      sync() {
        this.button.disabled = this.mainButton.disabled;
        const label = this.mainButton.querySelector('span');
        if (label && label.textContent.trim()) this.button.textContent = label.textContent.trim();
      }

      syncPrice() {
        const section = this.closest('section') || document;
        const price = section.querySelector('.price .price-item--last, .price .price-item--sale, .price .price-item--regular');
        if (price && this.price) this.price.textContent = price.textContent.trim();
      }
    }
  );
}
